import { render } from "./View.vue?vue&type=template&id=3f261b81"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Organisation/View.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f261b81"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f261b81', __exports__)) {
    console.log('reload')
    api.reload('3f261b81', __exports__)
  }
  
  module.hot.accept("./View.vue?vue&type=template&id=3f261b81", () => {
    console.log('re-render')
    api.rerender('3f261b81', render)
  })

}


export default __exports__